<div class="card" [class.shadow]="active" style="margin-bottom: 15px;" [id]="practitioner.id">
  <div class="card-body">
    <div class="row">
      <div class="col-md-auto d-flex flex-column justify-content-center">
        <img alt="profile-image" height="140" width="140" [src]="practitioner.profileImage">
        <div class="d-flex flex-fill" [class.justify-content-center]="!isMobileScreen" [class.justify-content-start]="isMobileScreen" style="margin-top: 17px;">
          <app-star-ratings *ngIf="practitioner.rating" [rating]="practitioner.rating.rating" [count]="practitioner.rating.total"></app-star-ratings>
        </div>
      </div>
      <div class="col-md-auto flex-fill">
        <div class="flex-fill practitioner-name"><a [routerLink]="['/practitioner', practitioner.id]">{{ practitioner.firstName + ' ' + practitioner.lastName }}</a></div>
        <div class="specialty-text">
          <span *ngFor="let specialty of practitioner.specialties; let i = index">
            {{ specialty.name }}<span *ngIf="i !== practitioner.specialties.length - 1">,</span>
          </span>
        </div>
        <div class="address-text">
          {{ practitioner.location.getFullAddress() }}
        </div>
        <div class="d-flex flex-wrap align-items-end mt-4" *ngIf="!isMobileScreen">
          <div class="card-subtitle d-flex flex-wrap" *ngIf="matchedTerms.length; else noTerms">
            <span class="card-pill" *ngFor="let term of matchedTerms; let i = index">{{term}}</span>
          </div>
          <ng-template #noTerms>
            <div class="card-subtitle d-flex">
              <span class="card-pill" i18n="search result|Used to show the user that the results shown are based on their location (distance).@@labelDistance">based on distance</span>
            </div>
          </ng-template>
        </div>
        <div class="d-flex flex-wrap mt-4 practitioner-details align-items-center" *ngIf="!isMobileScreen">
          <div class="practitioner-cost">
            <ng-container i18n="search result|Shows what the starting cost of the service is.@@labelStartingCost">
              Starting at</ng-container> £{{ practitioner.getStartingCost() }}
          </div>
          <div>
            <img src="../../../../assets/images/location.svg" alt="location" class="detail-icon">
            <span style="vertical-align: middle;">{{ distance }}</span>
          </div>
          <!-- <div>
            <span>
              <ng-container i18n="insurance options|The allowed insurance options to be displayed for dropdowns.@@labelInsuranceOptions">
                { practitioner.getInsurance(), select, All {All} Private {Private} Public {Public}}
              </ng-container>
              <ng-container i18n="label|The type of insurance a practitioner offers.@@labelInsurance">Insurance</ng-container>
            </span>
          </div> -->
          <div>{{ practitioner.getLanguages() }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="isMobileScreen">
      <div class="d-flex flex-wrap align-items-end" style="margin-top: 10px;">
        <div class="card-subtitle d-flex flex-wrap" *ngIf="matchedTerms.length; else noTerms">
          <span class="card-pill" *ngFor="let term of matchedTerms; let i = index">{{term}}</span>
        </div>
        <ng-template #noTerms>
          <div class="card-subtitle d-flex">
            <span class="card-pill" i18n="search result|Used to show the user that the results shown are based on their location (distance).@@labelDistance">based on distance</span>
          </div>
        </ng-template>
      </div>
      <div class="d-flex flex-wrap align-items-end practitioner-details" style="margin-top: 17px;">
        <div>
          <span style="vertical-align: middle;"><b><ng-container i18n="search result|Shows what the starting cost of the service is.@@labelStartingCost">
            Starting at</ng-container> £{{ practitioner.getStartingCost() }}</b>
          </span>
        </div>
        <div>
          <img src="../../../../assets/images/location.svg" alt="location" class="detail-icon">
          <span style="vertical-align: middle;">{{ distance }}</span>
        </div>
        <!-- <div>
          <span style="vertical-align: middle;">
            <ng-container i18n="insurance options|The allowed insurance options to be displayed for dropdowns.@@labelInsuranceOptions">
              { practitioner.getInsurance(), select, All {All} Private {Private} Public {Public}}
            </ng-container>
            <ng-container i18n="label|The type of insurance a practitioner offers.@@labelInsurance">Insurance</ng-container>
          </span>
        </div> -->
        <div>
          <span style="vertical-align: middle;">{{ practitioner.getLanguages() }}</span>
        </div>
      </div>
    </div>
    <button
      gaEvent
      gaCategory="Search Page"
      [gaAction]="'Book a session'"
      [gaLabel]="'mobile-click'"
      *ngIf="currentWindowWidth <= 1000"
      class="btn btn-primary schedule-btn"
      type="button"
      (click)="booking.open()"
      style="margin-top: 20px; width: 100%;"
      i18n="button|The button text for booking an appointment.@@buttonScheduleVisit">Book a session</button>
  </div>
  <div class="card-actions d-flex flex-column align-items-center" *ngIf="currentWindowWidth > 1000">
    <button
      gaEvent
      gaCategory="Search Page"
      [gaAction]="'Book a session'"
      [gaLabel]="'click'"
      class="btn btn-primary schedule-btn"
      type="button"
      (click)="booking.open()"
      i18n="button|The button text for booking an appointment.@@buttonScheduleVisit">Book a session</button>
    <button class="btn btn-primary search-button mt-2" type="button">
      <a [routerLink]="['/practitioner', practitioner.id]" i18n="button|Allows a user to share a practitioner's profile link.@@linkSharePractitioner">View profile</a>
    </button>
  </div>
</div>

<app-modal-notification #confirmation></app-modal-notification>
<app-booking-form #booking [practitioner]="practitioner" (bookingCompleted)="openConfirmation()"></app-booking-form>
